/**
* Feature Hero Module
**/

VP = window.VP || {};

(function( $ ) {
	VP.featuredHero = {

		$featuredHeroBody:$("body.page-template-page-media-center,body.home"),
		$featuredHeroContainer:$('.vp-module__featured-hero'),

		init: function () {
			var _this = this;
			if (!_this.$featuredHeroContainer.length || !_this.$featuredHeroBody.length) {
				// console.log("[featuredHero] no init");
      	return;
      }

			_this.initFeaturedHero();
			VP.documentEvents.onResize( _this.onResize.bind( _this ), true );
			 _this.onResize();
			// _this.setHeroHeight("300");
		},

		initFeaturedHero: function() {
			// console.log("[featuredHero] initFeaturedHero");
			var _this = this;
			var lazyloadImage = $('.vp-featured-hero__background img', _this.$featuredHeroContainer);

			var lazyloadCheck = setInterval(function(){
				if (lazyloadImage.hasClass('lazyloaded')) {
					_this.$featuredHeroContainer.addClass('vp-module__featured-hero--enhanced');
					clearInterval(lazyloadCheck);
				}
			}, 300);


		},
		onResize: function () {
			// console.log("[featuredHero] onResize");
      var _this = this;
      if (_this.$featuredHeroContainer.height() > window.innerHeight) {
      	_this.setHeroHeight(window.innerHeight);
      }
    },
    setHeroHeight: function(wheight) {
    	var _this = this;
    	// console.log("[featuredHero] set height: " + wheight);

    	_this.$featuredHeroContainer.height(wheight);
    	_this.$featuredHeroBody.css("marginTop",wheight);
    }

	};
})(jQuery);
